// ולידציה לטופס דיגיטלי

export function validateDigitalForm(values) {
    const errors = {};

    // פרטי הנתמך
    // שם פרטי - חובה
    if (!values.beneficiaryFirstName?.trim()) errors.beneficiaryFirstName = 'יש למלא שם פרטי נתמך';
    // שם פרטי/משפחה - רק אותיות
    if (values.beneficiaryFirstName && !/^[א-תa-zA-Z\s'-]+$/.test(values.beneficiaryFirstName)) errors.beneficiaryFirstName = 'יש להזין שם תקין (אותיות בלבד)';
    if (values.beneficiaryLastName && !/^[א-תa-zA-Z\s'-]+$/.test(values.beneficiaryLastName)) errors.beneficiaryLastName = 'יש להזין שם תקין (אותיות בלבד)';
    // שם משפחה - חובה
    if (!values.beneficiaryLastName?.trim()) errors.beneficiaryLastName = 'יש למלא שם משפחה נתמך';
    // תעודת זהות - חובה
    if (values.beneficiaryIdType === 'passport') {
        if (!values.beneficiaryIdNumber?.trim()) errors.beneficiaryIdNumber = 'יש למלא מספר דרכון נתמך';
        if (values.beneficiaryIdNumber && !validatePassport(values.beneficiaryIdNumber)) errors.beneficiaryIdNumber = 'מספר דרכון לא תקין';
    } else {
        if (!values.beneficiaryIdNumber?.trim()) errors.beneficiaryIdNumber = 'יש למלא תעודת זהות נתמך';
        if (values.beneficiaryIdNumber && !validateIdNumber(values.beneficiaryIdNumber)) errors.beneficiaryIdNumber = 'תעודת זהות לא תקינה';
    }
    // כתובת - חובה
    if (!values.beneficiaryAddress?.trim()) errors.beneficiaryAddress = 'יש למלא כתובת נתמך';
    //שם האב - חובה
    if (!values.beneficiaryFatherName?.trim()) errors.beneficiaryFatherName = 'יש למלא שם האב';
    //שם האם-חובה
    if (!values.beneficiaryMotherName?.trim()) errors.beneficiaryMotherName = 'יש למלא שם האם';
    // טלפון
    if (!values.beneficiaryPhone?.trim()) errors.beneficiaryPhone = 'יש למלא טלפון נתמך';
    if (values.beneficiaryPhone && !validatePhone(values.beneficiaryPhone)) errors.beneficiaryPhone = 'מספר טלפון לא תקין';
    // אימייל - not required, but validate format if provided
    if (values.beneficiaryEmail && !/^\S+@\S+\.\S+$/.test(values.beneficiaryEmail)) errors.beneficiaryEmail = 'כתובת אימייל לא תקינה';
    // ולידציה לכל שדות התמיכה
    if (!values.supportType) errors.supportType = 'יש לבחור סוג תמיכה';

    if (values.supportType === 'tuition') {
        // אפשר לבדוק אם יש קבצים (אם נדרש)
        if (!values.tuitionFiles || values.tuitionFiles.length === 0) errors.tuitionFiles = 'יש להעלות טפסים נדרשים';
    }

    if (values.supportType === 'welfare') {
        if (!values.welfareSupportType) errors.welfareSupportType = 'יש לבחור איך תתקבל התמיכה';
        if (!values.welfareSupportCount?.toString().trim()) errors.welfareSupportCount = 'יש למלא מספר התמיכות';
        // מספר התמיכות - רק מספר חיובי
        if (values.welfareSupportCount && (!/^\d+$/.test(values.welfareSupportCount) || Number(values.welfareSupportCount) <= 0)) errors.welfareSupportCount = 'יש להזין מספר תקין (חיובי)';
        if(!values.caregiverContactName?.trim()) errors.caregiverContactName = 'יש למלא שם איש קשר מטפל';
        if(!values.caregiverContactPhone?.trim()) errors.caregiverContactPhone = 'יש למלא טלפון איש קשר מטפל';
        if (values.caregiverContactPhone && !validatePhone(values.caregiverContactPhone)) errors.caregiverContactPhone = 'מספר טלפון לא תקין';
    }

    if (values.supportType === 'wedding') {
        if (!values.groomName?.trim()) errors.groomName = 'יש למלא שם החתן';
        if (!values.yeshiva?.trim()) errors.yeshiva = 'יש למלא ישיבה';
        if (!values.weddingDate?.trim()) errors.weddingDate = 'יש למלא תאריך החתונה';
        // תאריך חתונה - לא ישן
        if (values.weddingDate) {
            const today = new Date();
            const inputDate = new Date(values.weddingDate);
            today.setHours(0,0,0,0);
            if (inputDate < today) errors.weddingDate = 'לא ניתן לבחור תאריך חתונה ישן';
        }
        if (!values.weddingHall?.trim()) errors.weddingHall = 'יש למלא שם אולם';
    }
    // פירוט הסיבה לבקשה - חובה
    if (!values.requestReason?.trim()) errors.requestReason = 'יש למלא סיבה לבקשה';

    if (values.supportPaymentType === 'supplier') {
        // פרטי ספק
        // שם ספק - חובה
        if (!values.supplierName?.trim()) errors.supplierName = 'יש למלא שם ספק';
        // מס עוסק פטור - חובה
        if (!values.supplierId?.trim()) errors.supplierId = 'יש למלא מס עוסק פטור';
    }
    // פרטי חשבון בנק
    // מספר בנק - חובה
    if (!values.bankNumber?.trim()) errors.bankNumber = 'יש למלא מספר בנק';
    // מספרי בנק/סניף/חשבון - רק ספרות ואורך מתאים
    if (values.bankNumber && !/^\d{1,3}$/.test(values.bankNumber)) errors.bankNumber = 'מספר בנק לא תקין';
    if (!values.branchNumber?.trim()) errors.branchNumber = 'יש למלא מספר סניף';
    if (values.branchNumber && !/^\d{1,5}$/.test(values.branchNumber)) errors.branchNumber = 'מספר סניף לא תקין';
    if (!values.accountNumber?.trim()) errors.accountNumber = 'יש למלא מספר חשבון';
    if (values.accountNumber && !/^\d{4,12}$/.test(values.accountNumber)) errors.accountNumber = 'מספר חשבון לא תקין';

    // ולידציה על שדות ממלא הטופס
    if (!values.fillerFirstName?.trim()) errors.fillerFirstName = 'יש למלא שם פרטי של ממלא הטופס';
    if (!values.fillerLastName?.trim()) errors.fillerLastName = 'יש למלא שם משפחה של ממלא הטופס';
    if (!values.fillerRelation?.trim()) errors.fillerRelation = 'יש למלא קרבה לנתמך';
    if (!values.fillerPhone?.trim()) errors.fillerPhone = 'יש למלא טלפון ליצירת קשר';
    if (values.fillerPhone && !validatePhone(values.fillerPhone)) errors.fillerPhone = 'מספר טלפון לא תקין';
    if (!values.fillerSignature?.trim()) errors.fillerSignature = 'יש למלא חתימה';

    if (!values.charityAware) {
        errors.charityAware = 'יש לאשר את ההצהרה';
    }

    return errors;
}

export function validateIdNumber(id) {
    // בדיקת ת"ז ישראלית (ללא ספרת ביקורת)
    if (!id || id.length < 5 || id.length > 9 || !/^[0-9]+$/.test(id)) return false;
    id = id.padStart(9, '0');
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        let num = Number(id[i]) * ((i % 2) + 1);
        if (num > 9) num -= 9;
        sum += num;
    }
    return sum % 10 === 0;
}

export function validatePassport(passport) {
    // בדיקת דרכון בסיסית: לפחות 6 תווים, אותיות ומספרים
    return /^[a-zA-Z0-9]{6,15}$/.test(passport);
}

export function validatePhone(phone) {
    // בדיקת טלפון ישראלי
    return /^0[2-9]\d{7,8}$/.test(phone);
}
